<template>
    <div class="list-content-item">
        <h2 class="title" v-text="address.display_name"></h2>
        <div class="description text-uppercase" v-text="address.name"></div>
        <div class="text-right">
            <button @click="updateAddress" class="btn btn-sm btn-secondary text-dark">
                <i class="fa fa-eye mr-1"></i> View Details
            </button>
            <button @click="deleteAddress" class="btn btn-sm btn-danger">
                <i class="fa fa-trash mr-1"></i> Delete
            </button>
        </div>
    </div>
</template>
<script>
import mixins from "@utils/mixins";
import { route, destroy } from "@utils/network";

export default {
    name: "BookingAddressListItem",
    
    props: {
        address: [Object],
    },

    methods: {
        updateAddress() {
            this.$emit("update", this.address);
        },
        async deleteAddress() {
            if (!(await this.confirm("Are you sure you want to delete this booking address?", "")).value) {
                return;
            }
            destroy(route("shop-search-addresses/:id", { id: this.address.id }))
                .then(response => {
                    this.promptMessage(response.data.message.message, "")
                        .then(() => this.$emit("deleted"))
                })
                .catch(error => {
                    console.log(error);
                    this.promptErrors(error.response.data.message);
                });
        }
    },

    mixins: [mixins],

    mounted() {

    }
}
</script>